import { ErrorDetail, LibraryDocumentClient } from '@microsoft/esign.gateway.service.client';
import { ApprovalRequestType } from '../../data/types.generated';
import { getEsignGatewayProvider } from '../../utilities/EsignUtils';
import { fetchAndLog, getEsignGatewayConfiguration } from '../../views/Esign/utils/Authentication/EsignAuthHelpers';

export const uploadFileEsignGateway = async (approvalRequestType: ApprovalRequestType, file: File): Promise<string> => {
    try {
        const configuration = await getEsignGatewayConfiguration(approvalRequestType);
        const provider = getEsignGatewayProvider(approvalRequestType);
        const client = new LibraryDocumentClient(configuration, null, { fetch: fetchAndLog });
        const libraryDocumentId = await client.createLibraryDocument(provider, { data: file, fileName: file.name });
        return libraryDocumentId;
    } catch (error: any) {
        let errorDetail: ErrorDetail | null;
        try {
            errorDetail = JSON.parse(error.response);
        } catch {
            errorDetail = null;
        }

        if (error?.response) {
            error.response.data = {
                code: errorDetail?.innerError?.code,
            };
        }

        throw error;
    }
};
